module.exports = __webpack_public_path__ + "img/wolb_logo_img.2df6de9f.png";